import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SelectionOptions } from '@/models';

@Component
export default class FilterDropdown extends Vue {
  @Prop({ default: '' }) label: string;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: () => [] }) items: SelectionOptions;
  @Prop({ default: true }) multiple: boolean;
  @Prop({ default: () => [], required: false }) value: string[];

  private autocompleteProps = {
    dense: true,
    outlined: true,
    itemText: 'text',
    itemValue: 'value'
  };
  private optionValues = [] as string[] | string;
  
  created(): void {
    this.optionValues = [...this.value];
  }

  get displayValue(): string {
    const { value, items } = this;
    if (value.length === 1) {
      const selectedItem = items.find(item => item.value === value[0]);
      return '' + (selectedItem?.text || '');
    }
    return `${value.length} selected`;
  }

  onInputChanged(selectedValues: string[]): void {
    this.$emit('input', selectedValues);
  }

  @Watch('value')
  onSelectionOptionsPassed(): void {
    this.optionValues = [...this.value];
  }
}
